<template>
  <div class="ds-textbox-step-input">
    <span v-for="item in setpTemplateList" :key="item.index" class="ds-textbox-step-warp">
      <div v-if="item.type == 'input'" class="el-input">
        <input ref="input" class="el-input__inner" :class="{ 'is-disabled': disabled }" :char-index="item.index" :num="item.num" :maxlength="1" :type="inputType" :value="val[item.index]" :disabled="disabled" autocomplete="off" @input="onInput($event,item)" @focus="onFocus($event, item.num)" @blur="onBlur($event, item.num)" @compositionstart="onCompositionstart($event, item.num)" @compositionend="onCompositionend($event, item.num)" />
      </div>
      <span v-else class="ds-textbox-step-warp" split>{{ item.text }}</span>
    </span>
  </div>
</template>

<script>
const placeholder = " ";
export default {
  name: "DsfStepTextbox",
  model: {
    prop: "value",
    event: "model-value-mutation"
  },
  props: {
    value: {
      default: ""
    },
    inputType: {
      default: "text"
    },
    setpInputTemp: {
      default: "x"
    },
    setpTemplate: {
      default: "xxxx-xxxx"
    },
    // 输入前
    inputBefore: {
      type: Function,
      default: null
    },
    disabled: {
      default: false
    },
    //分隔符是否包含在值中
    splitCharInValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocus: false,
      isBlur: false,
      val: [],
      isStartComposition: false
    };
  },
  computed: {
    splitArr() {
      let arr = [];
      let index = 0;
      this.setpTemplateList.forEach((it, i) => {
        if (it.type == "split") {
          arr.push([i - index, it.text]);
          index = i + 1;
        }
        if (i >= this.setpTemplateList.length - 1) {
          arr.push([this.setpTemplateList.length - index]);
        }
      });
      return arr;
    },
    splitChars() {
      let arr = [];
      this.setpTemplateList.forEach((it, i) => {
        if (it.type == "split") {
          arr.push(it.text);
        }
      });
      return arr;
    },
    setpTemplateList() {
      const setpTemplate = this.setpTemplate;
      const list = [];
      let num = 0;
      for (let i = 0; i < setpTemplate.length; i++) {
        const item = {
          index: i
        };
        if (setpTemplate[i] == this.setpInputTemp) {
          item.type = "input";
          item.num = num++;
        } else {
          item.type = "split";
          item.text = setpTemplate[i];
        }
        if (!this.splitCharInValue) {
          item.index = item.num;
        }
        list.push(item);
      }
      return list;
    },
    inputNums() {
      return this.setpTemplateList.filter((it) => it.type == "input").length;
    }
  },
  methods: {
    formatVal(val) {
      let arr = [];
      let str = val;
      if (this.splitCharInValue) {
        _.each(this.splitChars, (it) => {
          str = str.replaceAll(it, "");
        });
        let strArr = str.split("");
        for (let i = 0; i < this.splitArr.length; i++) {
          let pos = this.splitArr[i];
          let length = pos[0];
          while (length) {
            let c = strArr.shift() || "";
            arr.push(c);
            length--;
          }
          if (pos[1]) {
            arr.push(pos[1]);
          }
        }
      } else {
        for (let i = 0; i < str.length; i++) {
          arr.push(str[i]);
        }
      }
      return arr.join("");
    },
    //监听输入法输入开始
    onCompositionstart(evt) {
      this.isStartComposition = true;
    },
    //监听输入法输入完成
    onCompositionend(evt) {
      if (this.isStartComposition == false) {
        return;
      }
      //兼容火狐需要做一次延迟
      let clearId = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(clearId);
        this.isStartComposition = false;
        let el = evt.target;
        var e = document.createEvent("HTMLEvents");
        e.initEvent("input", true, true);
        e.data = evt.data;
        el.dispatchEvent(e);
      });
    },
    onInput(ev, item) {
      if (!this.isStartComposition) {
        let v = ev.data;
        let size = 1;
        let input;
        // let i = item.index;
        let num = item.num;
        if (v) {
          size = v.length;
          input = this.getInputDom(num + size);
        }
        if (v == placeholder) v = "";
        if (dsf.isFunction(this.inputBefore)) {
          v = this.inputBefore(v);
        }
        const val = [...this.val];

        val[item.index] = v;
        this.$set(this, "val", val);
        this.valueChange(val);
        this.$nextTick(() => {
          this.inputAutoFocus(input);
        });
      }
    },
    onFocus(ev, i) {
      this.$emit("focus");
      this.isFocus = true;
      this.isBlur = false;
    },
    onBlur(ev, i) {
      this.isBlur = true;
      let raf = window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(raf);
        if (this.isBlur) {
          this.$emit("blur");
        }
      });
    },
    getInputDom(i) {
      return this.$refs.input[i];
    },
    valueChange(val) {
      let v = [];
      if (this.splitCharInValue) {
        _.each(this.setpTemplateList, (it, i) => {
          let index = it.index;
          v.push(this.val[index] || placeholder);
        });
      } else {
        _.each(this.setpTemplateList, (it, i) => {
          if (it.type == "input") {
            let index = it.index;
            v.push(this.val[index] || placeholder);
          }
        });
      }
      v = v.join("");
      if (!v.trim()) {
        v = "";
      }
      this.$emit("model-value-mutation", v);
      this.$emit("change", v);
    },
    inputAutoFocus(input) {
      input?.focus?.();
    }
  },
  watch: {
    value: {
      handler(v) {
        const val = [];
        v = this.formatVal(v);
        this.setpTemplateList.forEach((it, i) => {
          let index = it.index;
          let nv = v?.[index] || "";
          if (nv == placeholder) {
            nv = "";
          }
          if (!this.splitCharInValue) {
            if (it.type == "input") {
              val.push(nv);
            }
          } else {
            val.push(nv);
          }
        });
        this.$set(this, "val", val);
      }
    },
    setpTemplateList: {
      handler(v, ov) {
        _.each(this.setpTemplateList, (it, i) => {
          let index = it.index;
          if (dsf.isUnDef(this.val[index])) {
            if (it.type == "split" && this.splitCharInValue) {
              let text = it.text;
              this.$set(this.val, index, text);
            } else {
              this.$set(this.val, index, "");
            }
          }
        });
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    const inputs = this.$refs.input;
    for (let i = 0; i < inputs.length; i++) {
      let inputDom = $(inputs[i]);
      let num = ~~inputDom.attr("num");
      let charIndex = inputDom.attr("char-index");
      inputDom
        .on("keydown", (ev) => {
          if (ev.keyCode == 8) {
            if (!this.val[charIndex]) {
              let input = this.getInputDom(i - 1);
              // input?.focus();
              this.inputAutoFocus(input);
            }
          } else if (ev.keyCode == 37 || ev.keyCode == 39) {
            ev.preventDefault();
            let offset = ev.keyCode == 37 ? -1 : 1;
            let input = this.getInputDom(i + offset);
            if (input) {
              this.inputAutoFocus(input);
              // input?.focus();
            }
          }
        })
        .on("paste", (e) => {
          e.originalEvent.preventDefault();
          let text = e.originalEvent.clipboardData.getData("text");
          const val = [...this.val];
          let offset = Math.min(this.inputNums - num, text.length);
          val.splice(num, offset, ...text.slice(0, offset).split(""));
          this.$set(this, "val", val);
          this.valueChange(val);
          setTimeout(() => {
            let input = this.getInputDom(num + offset);
            this.inputAutoFocus(input);
          });
        });
    }
  },
  beforeDestroy() {
    const inputs = this.$refs.input;
    for (let i = 0; i < inputs.length; i++) {
      let inputDom = $(inputs[i]);
      inputDom.off("keydown").off("paste");
    }
  }
};
</script>